export default __webpack_public_path__ + "static/media/contacts-icon-union.c193f216.svg";